module.exports = __webpack_public_path__ + "static/media/icono_enviar.0fce89ba.svg";